var map = {
	"./de/common.json": 78032,
	"./de/common/base-layout.json": 28982,
	"./de/data-protection.json": 15984,
	"./de/default.json": 93869,
	"./de/document-templates/businessplan.json": 97434,
	"./de/document-templates/canvas.json": 25723,
	"./de/entityTypes/address.json": 17499,
	"./de/entityTypes/category.json": 99149,
	"./de/entityTypes/chapter.json": 74878,
	"./de/entityTypes/document.json": 28529,
	"./de/entityTypes/idea.json": 99501,
	"./de/entityTypes/program.json": 60785,
	"./de/entityTypes/project.json": 54942,
	"./de/entityTypes/projectFollowership.json": 3461,
	"./de/entityTypes/provider.json": 25101,
	"./de/entityTypes/sdg.json": 14474,
	"./de/entityTypes/supportRequest.json": 93497,
	"./de/entityTypes/user.json": 64661,
	"./de/entityTypes/userObjectRole.json": 15255,
	"./de/error.json": 70345,
	"./de/faq/faq-documents.json": 82199,
	"./de/faq/faq-meta.json": 59934,
	"./de/faq/faq.json": 82227,
	"./de/goto.json": 63423,
	"./de/management.json": 79457,
	"./de/static/imprint.json": 74594,
	"./de/static/netiquette.json": 14952,
	"./de/static/terms-of-use.json": 88075,
	"./de/usecases/action-request-operations.json": 44486,
	"./de/usecases/address-operations.json": 69287,
	"./de/usecases/category-operations.json": 68684,
	"./de/usecases/document-operations.json": 64358,
	"./de/usecases/events.json": 57699,
	"./de/usecases/external-provider.json": 64216,
	"./de/usecases/feedback-operations.json": 72718,
	"./de/usecases/follow-project.json": 45092,
	"./de/usecases/idea-operations.json": 47743,
	"./de/usecases/map.json": 60610,
	"./de/usecases/market.json": 27962,
	"./de/usecases/my-projects.json": 474,
	"./de/usecases/network-project.json": 8010,
	"./de/usecases/onboarding.json": 91654,
	"./de/usecases/partner-market.json": 54309,
	"./de/usecases/platform-manager.json": 18314,
	"./de/usecases/platform.json": 50652,
	"./de/usecases/program-operations.json": 61945,
	"./de/usecases/project-operations.json": 86323,
	"./de/usecases/project-workflow.json": 54689,
	"./de/usecases/provider-operations.json": 67450,
	"./de/usecases/pubtools.json": 55913,
	"./de/usecases/report-entity.json": 99874,
	"./de/usecases/sharing.json": 49695,
	"./de/usecases/single-multi.json": 80803,
	"./de/usecases/system.json": 40756,
	"./de/usecases/transition.json": 39040,
	"./de/usecases/user-operations.json": 72836,
	"./de/usecases/userObjectRole-operations.json": 34182,
	"./de/usecases/verification.json": 33226,
	"./de/usecases/video.json": 56102,
	"./en/common.json": 58645,
	"./en/common/base-layout.json": 39320,
	"./en/data-protection.json": 54984,
	"./en/default.json": 64097,
	"./en/document-templates/businessplan.json": 18431,
	"./en/document-templates/canvas.json": 32278,
	"./en/entityTypes/address.json": 6174,
	"./en/entityTypes/category.json": 34457,
	"./en/entityTypes/chapter.json": 76757,
	"./en/entityTypes/document.json": 56794,
	"./en/entityTypes/idea.json": 5405,
	"./en/entityTypes/program.json": 8888,
	"./en/entityTypes/project.json": 6716,
	"./en/entityTypes/projectFollowership.json": 61270,
	"./en/entityTypes/provider.json": 86118,
	"./en/entityTypes/sdg.json": 34609,
	"./en/entityTypes/supportRequest.json": 74221,
	"./en/entityTypes/user.json": 37780,
	"./en/entityTypes/userObjectRole.json": 2878,
	"./en/error.json": 16274,
	"./en/faq/faq-documents.json": 81091,
	"./en/faq/faq-meta.json": 72095,
	"./en/faq/faq.json": 22080,
	"./en/goto.json": 1423,
	"./en/management.json": 62186,
	"./en/static/imprint.json": 78377,
	"./en/static/netiquette.json": 95371,
	"./en/static/terms-of-use.json": 39168,
	"./en/usecases/action-request-operations.json": 37204,
	"./en/usecases/address-operations.json": 74645,
	"./en/usecases/category-operations.json": 59517,
	"./en/usecases/document-operations.json": 34955,
	"./en/usecases/events.json": 83611,
	"./en/usecases/external-provider.json": 67399,
	"./en/usecases/feedback-operations.json": 91205,
	"./en/usecases/follow-project.json": 74409,
	"./en/usecases/idea-operations.json": 92811,
	"./en/usecases/map.json": 68631,
	"./en/usecases/market.json": 4432,
	"./en/usecases/my-projects.json": 79179,
	"./en/usecases/network-project.json": 19122,
	"./en/usecases/onboarding.json": 40273,
	"./en/usecases/partner-market.json": 86183,
	"./en/usecases/platform-manager.json": 70303,
	"./en/usecases/platform.json": 140,
	"./en/usecases/program-operations.json": 75622,
	"./en/usecases/project-operations.json": 91795,
	"./en/usecases/project-workflow.json": 37274,
	"./en/usecases/provider-operations.json": 81039,
	"./en/usecases/pubtools.json": 39277,
	"./en/usecases/report-entity.json": 11735,
	"./en/usecases/sharing.json": 46988,
	"./en/usecases/single-multi.json": 30656,
	"./en/usecases/system.json": 87739,
	"./en/usecases/transition.json": 81502,
	"./en/usecases/user-operations.json": 51253,
	"./en/usecases/userObjectRole-operations.json": 78126,
	"./en/usecases/verification.json": 39397,
	"./en/usecases/video.json": 711,
	"./example.json": 5414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66910;